import { IScope } from "angular";
import { PerfilService } from "../../services/perfil/perfil.service";

export class OrderActionsController {
  /**
   * @param {IScope} $scope
   * @param {PerfilService} Perfil
   */
  constructor($scope, Perfil) {
    "ngInject";

    $scope.popoverOpts = {
      template: require("../../app/common/integration-popover/integration-popover.html"),
      trigger: "outsideClick",
      placement: "left",
      class: "integration-popover",
    };

    this.Perfil = Perfil;
    this.$scope = $scope;
  }

  $onInit() {
    this.populateUser();
  }

  printLabels(orders) {
    this.print(orders);
  }

  printLabelsLote() {
    this.printLote();
  }

  deleteAllLote() {
    this.deleteAll()
  }

  async populateUser() {
    try {
      const user = await this.Perfil.getUserData();
      this.$scope.user = await this.Perfil.getClienteData(user.id);
    } catch (e) {
      console.error(e);
    }
  }
}
